import type { Price } from '@backmarket/http-api'

export type Answer = {
  key: string
  value: string
}

export interface InfoBlock {
  title: string
  paragraphs: Array<string>
}

export interface Offer {
  price: Price
  productShortTitle: string
  productImage?: string
  partnerOfferUrl: string
}

// type guard used to validate offer stored in local storage
export function isOffer(value: unknown): value is Offer {
  return (
    typeof value === 'object' &&
    value !== null &&
    'productShortTitle' in value &&
    'price' in value &&
    'partnerOfferUrl' in value &&
    'productImage' in value
  )
}

export interface Option {
  label: string
  value: string
  image?: string
  description: string
  maxPriceEstimate?: Price
}

export interface Question {
  key: string
  title: string
  type: 'select' | 'radioline'
  lastQuestion: boolean
  options: Array<Option>
  infoBlock?: InfoBlock
}
